import { useState } from "react";

import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { BsThreeDots } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";

import { ECourseStatus, TCourse } from "../../../../../@types";
import { useMyServices } from "../../../../../hooks/useMyServices";

export type TCourseItemProps = {
	course: TCourse;
};

export function CourseItem({ course }: TCourseItemProps) {
	const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
	const { cloneCourse } = useMyServices();
	const navigate = useNavigate();

	const numberOfLessons = course.lesson.length;
	let numberOfLessonsText = "";
	if (numberOfLessons === 1) {
		numberOfLessonsText = "1 Class";
	} else {
		numberOfLessonsText = `${numberOfLessons} Classes`;
	}
	const courseTime = course.lesson.reduce(
		(acc, cur) => acc + (cur.teachingTime ?? 0) + (cur.flightTime ?? 0),
		0,
	);

	const onClickCloneCourse = async () => {
		setMenuAnchor(null);
		const newCourse = await cloneCourse(course.id);
		if (newCourse) {
			navigate(`/my-services/${newCourse.courseSlug}/description`);
		}
	};

	return (
		<div>
			<div className="course-item-container item-separator-small">
				<div className="course-title-container">
					<Typography className="big-text bold" flex={1}>
						{course.name}
					</Typography>
					{course.status === ECourseStatus.FLYING && (
						<div className="course-status-container">
							<div className="green-bullet" />
							<Typography className="normal-text">Published</Typography>
						</div>
					)}
					{course.status === ECourseStatus.GROUNDED && (
						<div className="course-status-container">
							<div className="yellow-bullet" />
							<Typography className="normal-text">Unpublished</Typography>
						</div>
					)}
					<IconButton
						className="icon-button"
						onClick={(e) => {
							setMenuAnchor(e.currentTarget);
						}}>
						<BsThreeDots />
					</IconButton>
					<Menu
						open={Boolean(menuAnchor)}
						anchorEl={menuAnchor}
						className="option-menu"
						onClose={() => {
							setMenuAnchor(null);
						}}>
						<MenuItem onClick={onClickCloneCourse} className="normal-text">
							Clone
						</MenuItem>
					</Menu>
				</div>
				<div className="separator" />
				<div className="course-information-container">
					<Typography className="normal-text">{numberOfLessonsText}</Typography>
					<Typography className="normal-text">
						{`${(courseTime / 60).toFixed(1)} Hours`}
					</Typography>
				</div>
				<div className="course-information-container">
					<Link
						to={`/my-services/${course.courseSlug}/description`}
						className="black-text">
						<Typography className="normal-text bold">
							Edit / View /Track
						</Typography>
					</Link>
				</div>
			</div>
		</div>
	);
}
